// extracted by mini-css-extract-plugin
module.exports = {"wpdetail":"wpdetail--N0CW3","fadeOut":"fadeOut--vLW43","loading":"loading--1S0q7","fadeOutAuthor":"fadeOutAuthor--14ZTG"};